import { axios } from '@Root/API'

export const edit = data => {
	return axios.post('help-text-page/store', data)
}
